import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "@firebase/firestore";
import Constants from 'expo-constants'
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { getRemoteConfig } from "firebase/remote-config";

// O `.env` de cada cliente costuma ser preenchido colando o objeto de config do
// console do Firebase, o que deixa resíduos: valor entre aspas e vírgula no fim
// (`appId: "1:123:web:abc",`). O dotenv só remove as aspas quando elas envolvem
// o valor INTEIRO — com a vírgula depois da aspa final ele entrega
// `"1:123:web:abc",` literalmente.
//
// Isso é traiçoeiro porque quebra pouca coisa e sem alarde: só o Installations
// envia o `appId`, então Firestore, Auth e Storage seguem funcionando e apenas o
// Remote Config morre (400 INVALID_ARGUMENT), derrubando TODAS as
// funcionalidades para os defaults `false`. Limpar aqui evita o problema em
// qualquer projeto.
const clean = (value) => {
  if (typeof value !== 'string') return value;
  return value
    .trim()
    .replace(/,+$/, '')
    .replace(/^(['"])([\s\S]*)\1$/, '$2')
    .trim();
};

const firebaseConfig = {
  apiKey: clean(Constants.manifest.extra.apiKey),
  authDomain: clean(Constants.manifest.extra.authDomain),
  projectId: clean(Constants.manifest.extra.projectId),
  storageBucket: clean(Constants.manifest.extra.storageBucket),
  messagingSenderId: clean(Constants.manifest.extra.messagingSenderId),
  appId: clean(Constants.manifest.extra.appId),
  measurementId: clean(Constants.manifest.extra.measurementId)
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const remoteConfig = getRemoteConfig(app);

// Só no build dos testes de ponta a ponta (tests/e2e): USE_FIREBASE_EMULATORS=1
// aponta o app para os emuladores locais. Em produção a variável não existe e
// nada aqui roda. O teste do host é a segunda trava: um build de teste
// publicado por engano (`firebase deploy` da pasta web-build) não pode deixar
// o app de um cliente apontando para localhost.
const isLocalHost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location?.hostname);
if (Constants.manifest.extra.useFirebaseEmulators && isLocalHost) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
}

// Defaults aplicados ANTES de qualquer fetch, e também quando o fetch falha.
//
// Só entram aqui as chaves cujo estado seguro é `true`. As funcionalidades
// comuns ficam de fora de propósito: elas devem nascer desligadas e só ligar
// quando o cliente as liga. `blockScreenCapture` é uma trava protegendo
// conteúdo pago — deixá-la `false` até o Remote Config responder abriria uma
// janela em todo boot do app em que a gravação de tela passaria livre.
remoteConfig.defaultConfig = {
  ...remoteConfig.defaultConfig,
  blockScreenCapture: true, // bloqueia por padrão até o remote config responder
};
